'use strict';

const Mn = require('backbone.marionette');
const Moment = require('moment');
const Tooltip = require('common/ui/view/behavior/tooltip');
const ReadMore = require('common/ui/view/behavior/readmore');
const MyActionStatusRepository = require('balus/domain/repository/my/action-status');
const ActionItemTemplate = require('balus/ui/template/body/my-actions/content/action-item.hbs');

const ActionView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item',
    template: ActionItemTemplate,
    behaviors: [Tooltip],

    templateContext: function() {
        const today = Moment();
        const endAt = this.model.getEndAt();
        const lastDays = Moment(endAt).diff(today, 'days');
        const delayedDays = -lastDays;
        const isDelayed = lastDays < 0;

        return {
            projectImageURL: this.model.getProjectImageURL(),
            link: this.model.getActionURL(),
            projectURL: this.model.getProjectURL(),
            stateType: this.model.getStateType(),
            lastDays: lastDays,
            delayedDays: delayedDays,
            isDelayed: isDelayed,
            assignees: this.model.getAssignees()
        }
    }
});

module.exports = Mn.CollectionView.extend({
    childView: ActionView,
    className: 'list',
    behaviors: {
        ReadMore: {
            behaviorClass: ReadMore,
            showReadMore: function() {
                const group = this.getOption('group');
                return MyActionStatusRepository.find(group).hasNext();
            },
            onReadMore: function() {
                const group = this.getOption('group');
                MyActionStatusRepository.find(group).fetchNext(10);
            }
        }
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/my-actions/content/action-status-list.js